import React, { Component } from 'react';
import './App.css';
import { Router, navigate, Match } from "@reach/router";
import db from './core/FirebaseDb.js';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import RoomSensor from './components/RoomSensor.js';
import PlantSensor from './components/PlantSensor.js';

class App extends Component {

  _measuresCollectionName = 'measures';
  _roomDbId = 'room';
  _plantDbId = 'plant';
  _recordsLimit = 100;

  constructor(props) {
    super(props);

    this.state = { tabValue: 0, roomRows: [], plantRows: [] };

    this.roomMeasuresQuery = db.collection(this._measuresCollectionName)
      .orderBy('timestamp', 'desc')
      .where('sensorType', '==', db.doc('/sensorTypes/room'))
      .limit(this._recordsLimit);

    this.plantMeasuresQuery = db.collection(this._measuresCollectionName)
      .orderBy('timestamp', 'desc')
      .where('sensorType', '==', db.doc('/sensorTypes/plant'))
      .limit(this._recordsLimit);

    // This binding is necessary to make `this` work in the callback
    this.createItem = this.createItem.bind(this);
    this.updateData = this.updateData.bind(this);
    this.updateRoomData = this.updateRoomData.bind(this);
    this.updatePlantData = this.updatePlantData.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleTabChange(event, value) {

    if (value === 0) {
      navigate('/room');
    } else {
      navigate('/plant');
    }

  }

  componentWillMount() {
    const $this = this;

    this.roomMeasuresQuery.onSnapshot(
      querySnapshot => $this.updateRoomData(querySnapshot),
      error => console.error('Error getting room document: ', error)
    );

    this.plantMeasuresQuery.onSnapshot(
      querySnapshot => $this.updatePlantData(querySnapshot),
      error => console.error('Error getting plant document: ', error)
    );

  }

  componentDidUpdate(prevProps) {
    window.scrollTo(0, 0);
  }

  updateData(querySnapshot, done) {
    const $this = this;
    let id = 0;

    querySnapshot.forEach(function(docRef) {
      const rowData = $this.createData(docRef.data(), id++);
      done(rowData);

      console.log('doc', rowData);
    });
  }

  updateRoomData(querySnapshot) {
    const data = [];

    this.updateData(querySnapshot, rowData => data.push(rowData));

    this.setState({
      roomRows: data
    });
  }

  updatePlantData(querySnapshot) {
    const data = [];

    this.updateData(querySnapshot, rowData => data.push(rowData));

    this.setState({
      plantRows: data
    });
  }

  createItem() {
    console.log(db);

    db.collection('measures').add({
      temperature: 10.1,
      hygrometry: 10.1,
      altitude: 10.1,
      pressure: 10.1,
      sensorType: db.doc('/sensorTypes/room'),
      timestamp: Date.now()
    })
    .then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });
  }

  createData(measures, id) {
    Object.keys(measures).forEach(key => {
      if (measures[key] === undefined) {
        delete measures[key];
      }
    });

    return { id, ...measures };
  }

  render() {
  //<button onClick={ this.createItem }>Create item in db</button>
    return (
      <div className="App">
        <header className="App-header">
          <img width="48" src="/favicon.ico"/> Nature Power v1.0
        </header>
        <Tabs
          value={ this.state.tabValue }
          onChange={this.handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label='Room sensor' />
          <Tab label='Plant sensor' />
        </Tabs>
        <Router>
          <RoomSensor default rows={this.state.roomRows} path="/room" />
          <PlantSensor rows={this.state.plantRows} path="/plant" />
        </Router>
        <Match path="/*">
          {
            props => {
              if (props.match['*'] === 'room') {
                return this.state.tabValue !== 0 && this.setState({ tabValue: 0 });
              } else if(props.match['*'] === 'plant') {
                 return this.state.tabValue !== 1 && this.setState({ tabValue: 1 });
              }
            }
          }
        </Match>
      </div>
    );
  }
}

export default App;
